import { useQuery } from '@tanstack/react-query'
import { savedItemsService } from '../services/api'
import { useAuth } from '../contexts/AuthContext'
import { ITEMS_STALE_MS, shouldRetryItems } from '../utils/itemQueryPolicy'
import { savedItemsQueryKey } from '../utils/libraryIsolation'
import { canReusePreviousQueryData, getUserId } from '../utils/sessionUser'
import { useSignedMediaQueryRenewal } from './useSignedMediaQueryRenewal'

export function useSavedItemsQuery(options = {}) {
  const { user, token } = useAuth()
  const userId = getUserId(user)
  const { enabled: enabledOption, queryFn, ...rest } = options
  const enabled = !!token && !!userId && enabledOption !== false
  const queryKey = savedItemsQueryKey(userId)
  useSignedMediaQueryRenewal(queryKey, enabled)

  return useQuery({
    queryKey,
    queryFn: async () => {
      const result = queryFn ? await queryFn() : await savedItemsService.list()
      if (!Array.isArray(result)) {
        throw new Error('Réponse bibliothèque invalide')
      }
      const stillCurrent = getUserId(user)
      if (userId && stillCurrent && stillCurrent !== userId) {
        throw new Error('Réponse obsolète : la session utilisateur a changé')
      }
      return result
    },
    enabled,
    staleTime: ITEMS_STALE_MS,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchInterval: 120000,
    refetchIntervalInBackground: false,
    retry: (failureCount, error) => shouldRetryItems(failureCount, error),
    retryDelay: 1000,
    placeholderData: (previousData, previousQuery) => (
      canReusePreviousQueryData(previousQuery, userId) ? previousData : undefined
    ),
    ...rest,
  })
}
